export const COLUMNS = {
    SELECT_COLUMN: "selectColumn",
    PRODUCT_INFO__WITH_COMISSION: "productInfoWithComission",
    PRODUCT_CODE: "productCode",
    STOCK_CODE: "stockCode",
    GTIN: "gtin",
    MODEL_CODE: "modelCode",
    BRAND: "brand",
    CATEGORY_NAME: "categoryName",
    LIST_PRICE: "listPrice",
    SALES_PRICE: "salesPrice",
    STOCK: "stock",
    SENDER_TR: "senderTR",
    BUYBOX_PRICE: 'buyBoxPrice',
    STATUS: "status",
    ACTIONS: "actions",
    CATALOG_ID: "catalogId",
    PREPARING_TIME: "preparingTime",
    SHIPMENT_TEMPLATE: "shipmentTemplate",
    GROUP_ID: "groupId",
    ERROR_LABEL: "inApprovalReason",
    REJECT_REASON: "rejectInfo",
    VAT_RATES: "vatRate"
  };

export const COLUMN_NAMES = [
    COLUMNS.SELECT_COLUMN,
    COLUMNS.PRODUCT_INFO__WITH_COMISSION,
    COLUMNS.STOCK_CODE,
    COLUMNS.GTIN,
    COLUMNS.MODEL_CODE,
    COLUMNS.PRODUCT_CODE,
    COLUMNS.BRAND,
    COLUMNS.CATEGORY_NAME,
    COLUMNS.LIST_PRICE,
    COLUMNS.SALES_PRICE,
    COLUMNS.STOCK,
    COLUMNS.SENDER_TR,
    COLUMNS.BUYBOX_PRICE,
    COLUMNS.CATALOG_ID,
    COLUMNS.PREPARING_TIME,
    COLUMNS.SHIPMENT_TEMPLATE,
    COLUMNS.GROUP_ID,
    COLUMNS.STATUS,
    COLUMNS.ACTIONS,
    COLUMNS.ERROR_LABEL,
    COLUMNS.REJECT_REASON,
    COLUMNS.VAT_RATES
];

export const CATALOG_TABLE_COLUMNS = {
  SELECT_COLUMN: "selectColumn",
  VARIANT_INFO: "productVariantInfo",
  GTIN: "gtin",
  STOCK_CODE_WITH_INPUT: "stockCodeWithInput",
  LIST_PRICE: "listPrice",
  SALES_PRICE: "salePrice",
  STOCK: "stock",
  DURATION: "duration",
  ACTIONS: "actions",
  VAT_RATES: "vatRate"
};

export const CATALOG_TABLE_COLUMN_NAMES = [
  CATALOG_TABLE_COLUMNS.SELECT_COLUMN,
  CATALOG_TABLE_COLUMNS.VARIANT_INFO,
  CATALOG_TABLE_COLUMNS.GTIN,
  CATALOG_TABLE_COLUMNS.STOCK_CODE_WITH_INPUT,
  CATALOG_TABLE_COLUMNS.LIST_PRICE,
  CATALOG_TABLE_COLUMNS.SALES_PRICE,
  CATALOG_TABLE_COLUMNS.STOCK,
  CATALOG_TABLE_COLUMNS.DURATION,
  CATALOG_TABLE_COLUMNS.ACTIONS,
  CATALOG_TABLE_COLUMNS.VAT_RATES,
];

export const SINGULAR_PRODUCT_TABLE_COLUMNS = {
  SELECT_COLUMN: "selectColumn",
  COLOR: "color",
  IMAGES: "images",
  SIZE: "size",
  VARIANT_INFO: "productVariantInfo",
  GTIN: "gtin",
  STOCK_CODE_WITH_INPUT: "stockCodeWithInput",
  LIST_PRICE: "listPrice",
  SALES_PRICE: "salePrice",
  STOCK: "stock",
  DURATION: "duration",
  ACTIONS: "actions",
  VAT_RATES: "vatRate"
};

export const SINGULAR_PRODUCT_TABLE_COLUMN_NAMES = [
  SINGULAR_PRODUCT_TABLE_COLUMNS.SELECT_COLUMN,
  SINGULAR_PRODUCT_TABLE_COLUMNS.IMAGES,
  SINGULAR_PRODUCT_TABLE_COLUMNS.COLOR,
  SINGULAR_PRODUCT_TABLE_COLUMNS.SIZE,
  SINGULAR_PRODUCT_TABLE_COLUMNS.GTIN,
  SINGULAR_PRODUCT_TABLE_COLUMNS.STOCK_CODE_WITH_INPUT,
  SINGULAR_PRODUCT_TABLE_COLUMNS.LIST_PRICE,
  SINGULAR_PRODUCT_TABLE_COLUMNS.SALES_PRICE,
  SINGULAR_PRODUCT_TABLE_COLUMNS.STOCK,
  SINGULAR_PRODUCT_TABLE_COLUMNS.DURATION,
  SINGULAR_PRODUCT_TABLE_COLUMNS.ACTIONS,
  SINGULAR_PRODUCT_TABLE_COLUMNS.VAT_RATES,
];

export const VAT_RATES = {
  0: '%0',
  1: '%1',
  10: '%10',
  20: '%20',
};

export const SINGULAR_PRODUCT_TABLE_IMAGE_UPLOAD_ERROR_MESSAGES = {
  size: 'Dosya boyutu en fazla 10 MB olmalıdır.',
  dimension: 'Resim boyutu en fazla 5000px olmalıdır.'
}
